import * as React from 'react';
import BAEPForm from './BAEP';
import BloodPressureForm from './BloodPressure';
import ECGForm from './ECG';
import EchocardiographyForm from './Echocardiography';
import ENMGForm from './ENMG';
import FVCForm from './FVC';
import HeartRateForm from './HeartRate';
import NocturnalPolygraphyForm from './NocturnalPolygraphy';
import OCTSCANForm from './OCTSCAN';
import SEPForm from './SEP';
import VEPForm from './VEP';

import type { TDocument } from '../../utils';

const ClinicalStudyForm = ({ formData, document }: IOwnProps): React.JSX.Element | null => {
  switch (document?._type) {
    case 'fvc':
      return <FVCForm formData={formData} />;
    case 'enmg':
      return <ENMGForm formData={formData} />;
    case 'vep':
      return <VEPForm formData={formData} />;
    case 'sep':
      return <SEPForm formData={formData} />;
    case 'baep':
      return <BAEPForm formData={formData} />;
    case 'octscan':
      return <OCTSCANForm formData={formData} />;
    case 'ecg':
      return <ECGForm formData={formData} />;
    case 'echocardiography':
      return <EchocardiographyForm formData={formData} />;
    case 'bloodPressure':
      return <BloodPressureForm formData={formData} />;
    case 'heartRate':
      return <HeartRateForm formData={formData} />;
    case 'nocturnalPolygraphy':
      return <NocturnalPolygraphyForm formData={formData} />;
    default:
      return null;
  }
};

interface IOwnProps {
  formData: IFormData;
  document?: TDocument;
  viewing?: boolean;
}

export default ClinicalStudyForm;
